export const styles = () => ({
  emailInput: {
    width: "100%",
  },
  formWrapper: {
    alignItems: "center",
    display: "flex",
    gridGap: "1rem",
    marginBottom: "2rem",
  },
});



// WEBPACK FOOTER //
// ./src/features/director/pages/administrators/styles.ts